import { render, staticRenderFns } from "./GroupRightSideBar.vue?vue&type=template&id=7ab5786c&scoped=true&"
import script from "./GroupRightSideBar.vue?vue&type=script&lang=js&"
export * from "./GroupRightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupRightSideBar.vue?vue&type=style&index=0&id=7ab5786c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5786c",
  null
  
)

export default component.exports